import ButtonIconSecondary from 'components/molecules/buttons/ButtonIconSecondary';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { BRAND_DELETE } from 'constants/capabilities';

export default ProtectedComponent({ requiredCapabilities: [BRAND_DELETE] })(ButtonIconSecondary);



// WEBPACK FOOTER //
// ./src/components/molecules/buttons/DeleteBrandButton.js